const Colors = {
    primary: '#0098DB',
    secondary: '#E37222',
    accent: '#92D400',
};

export default Colors